export const ROLES = {
  ADMIN: "admin",
  MANAGER: "manager",
  INSPECTOR: "inspector",
} as const;

export type RoleCode = (typeof ROLES)[keyof typeof ROLES];

export const ROLE_NAMES_TH: Record<RoleCode, string> = {
  admin: "เจ้าหน้าที่ผู้ดูแลระบบ",
  manager: "ผู้จัดการการเดินรถ",
  inspector: "ผู้ตรวจสอบข้อมูล",
};

export function getThaiName(role: string): string {
  return ROLE_NAMES_TH[role as RoleCode] || "ไม่ทราบสิทธิ์";
}


export function hasRole(allowedRoles: RoleCode[], userRole: string): boolean {
  if (!userRole) return false
  const normalized = userRole.toLowerCase()
  if (normalized === ROLES.ADMIN) return true
  return allowedRoles.includes(normalized as RoleCode)
}